import { makeStyles, Theme } from '@material-ui/core/styles';

const buttonStyle = {
  width: '40%',
  color: 'white',
  maxWidth: 150,
};

export default makeStyles((theme: Theme) => ({
  titleInput: {
    width: '100%',
  },
  modalTitle: {
    color: theme.palette.success.main,
    textAlign: 'center',
  },
  greenButton: {
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.light,
    },
    ...buttonStyle,
  },
  yellowButton: {
    backgroundColor: theme.palette.warning.main,
    ...buttonStyle,
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  divisor: {
    margin: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(1),
    maxWidth: 750,
  },
  chip: {
    margin: theme.spacing(1),
  },
}));
